import "../../../assets/css/skeletons.css";
import svgContent from "../../../assets/img/logo-mjv-aira-star.svg"

const HomeSkeleton = () => {
  return (
    <div className="wrapper-content skeleton-home">
      <div className="main overflow-auto">
        <div className="container p-4">
          <div className="row">
            
          </div>
          <div className="row">
            <div className="col-12 col-subSection">
              <div className="loading-overlay d-flex justify-content-center align-items-center">
                <div 
                  className="loading-spinner" 
                >
                  <img src={svgContent} style={{width: '200px', height: '200px'}} alt="Aira Star Logo" />
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default HomeSkeleton;
